import { z } from "zod";

import { productionOptionUsedSchema } from "./production-option";
import { packagingComponentStagedSchema } from "./packaging-solution-staged";
import { packagingSolutionSchema } from "./packaging-solution";
import { packagingSolutionOptionsSchema } from "./packaging-solution-options";

const packagingComponentProducedSchema = packagingComponentStagedSchema.extend({
	usedProductionOption: productionOptionUsedSchema,
});

const packagingLabelProducedSchema = packagingComponentProducedSchema.extend({});

const packagingPrintProducedSchema = packagingComponentProducedSchema.extend({});

const packagingCartonProducedSchema = packagingComponentProducedSchema.extend({
	labels: z.array(packagingLabelProducedSchema),
	prints: z.array(packagingPrintProducedSchema),
});

export const packagingSolutionProducedSchema = packagingSolutionSchema.extend({
	licensePlateNumber: z.string().nullish(),
	options: packagingSolutionOptionsSchema.optional(),
	cartons: z.array(packagingCartonProducedSchema),
	labels: z.array(packagingLabelProducedSchema),
});

export type PackagingSolutionProduced = z.infer<typeof packagingSolutionProducedSchema>;
export type ProducedCarton = z.infer<typeof packagingCartonProducedSchema>;
export type ProducedLabel = z.infer<typeof packagingLabelProducedSchema>;
